module.exports = __webpack_public_path__ + "static/media/5.aa2a175a.png";


//////////////////
// WEBPACK FOOTER
// ./src/emoji/5.png
// module id = 223
// module chunks = 0